export default {
	
	props: {
		product: Number,
		typeTitle: String,
		codeTitle: String,
		qtyTitle: String,
		buttonTitle: String,
		emptyCode: String,
		emptyQty: String
	},
	data() {
		return {
			type: 0,
			code: "",
			qty: 0,
			comment: "",
			errorForm: "",
			errorProperty: "",
			typeList: []
		}
	},
	computed: {
		isErrorForm() {
			return  this.errorForm !== null && this.errorForm !== undefined && this.errorForm.length>0;
		},
		isErrorProperty() {
			return  this.errorProperty !== null && this.errorProperty !== undefined && this.errorProperty.length>0;
		}
	},
	methods: {
		addProductBarcode() {
			this.errorForm="";
			if (this.qty===0 || this.qty==="") {
				this.errorProperty=this.emptyQty;
			} else if (this.code==="") {
				this.errorProperty=this.emptyCode;
			} else {
				this.errorProperty="";
				var data = {
				  "product": this.product,
				  "type": this.type,
				  "code": this.code,
				  "qty": this.qty,
				  "comment": this.comment,
				}
				console.log(data);
				fetch("./api/productBarcodes", {
				  method: 'POST',
				  headers: { 'Content-Type': 'application/json; charset=utf-8' },
				  body: JSON.stringify(data)
				})
				.then(response => {
					if (response.ok) {
						//remove added campaign from list
						this.type=0;
						this.code="";
						this.qty="";
						this.comment="";
						//refresh table
						this.$emit('refresh');
					}
					else {
						console.error('Error:', response.status);
						this.errorForm="RestApi point return status:"+response.status;
					}
				})
				.catch((error) => {
				  console.error('Error:', error);
				  this.errorForm="Error to fetch restApi point";
				});
			}
		},
		loadData() {
			this.typeList=[];
			return fetch("./api/lists/pbty?onlyEnabled=true")
			.then(response => response.json())
			.then(data => {
				if (data !== null && data !== undefined) {
					this.typeList=data.items;
				}
				else {
					console.log("Loaded codeTypeList list is invalid");
					this.errorForm = "Loaded codeTypeList list is invalid";
				}
			})
			.catch((error) => {
				console.log("Error loading codeTypeList list:"+error);
				this.errorForm = error;
			});
		}
	},
	mounted() {
		this.loadData();
	},
	template:
`
<div v-if="isErrorForm" class="errors">
	<span class="perr">{{errorForm}}</span>
</div>
<table>
	<tr>
		<td>
			{{typeTitle}}: 
			<select v-model.number="type" tabindex='10'>
			  <option v-for="item in typeList" :value="item.value">
				{{ item.name }}
			  </option>
			</select>
		</td>
		<td>
			{{codeTitle}}: <input type="text" v-model="code" placeholder="EAN code" tabindex='20'/>
		</td>
		<td>
			{{qtyTitle}}: <input type="text" v-model.number="qty" placeholder="0" size="5" class="price" tabindex='30'/>
		</td>
		<td rowspan="2">
			<button class="button" @click="addProductBarcode" tabindex='50'>{{buttonTitle}}</button>
		</td>
	</tr>
	<tr>
		<td colspan="3"><textarea v-model="comment" cols='48' rows="2" tabindex='40' class="width100p"></textarea></td>
	</tr>
</table>
<span v-if="isErrorProperty" class="perr">{{errorProperty}}</span>
</div>`
}

